import { render } from "./AppConfig.vue?vue&type=template&id=5bb6642e&scoped=true"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"

import "./AppConfig.vue?vue&type=style&index=0&id=5bb6642e&scoped=true&lang=css"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb6642e"]])

export default __exports__